export const howToBookItems = [
  {
    id: 1,
    titleKey: 'listing.how-to-book.step-1.title',
    pointKeys: [
      { textKey: 'listing.how-to-book.step-1.point-1' },
      { textKey: 'listing.how-to-book.step-1.point-2' },
      { textKey: 'listing.how-to-book.step-1.point-3' }
    ]
  },
  {
    id: 2,
    titleKey: 'listing.how-to-book.step-2.title',
    pointKeys: [
      { textKey: 'listing.how-to-book.step-2.point-1' },
      { textKey: 'listing.how-to-book.step-2.point-2' }
    ]
  },
  {
    id: 3,
    titleKey: 'listing.how-to-book.step-3.title',
    pointKeys: [
      { textKey: 'listing.how-to-book.step-3.point-1' },
      { textKey: 'listing.how-to-book.step-3.point-2' },
      { textKey: 'listing.how-to-book.step-3.point-3' },
      {
        textKey: 'listing.how-to-book.step-3.point-4',
        subpointKeys: [
          'listing.how-to-book.step-3.point-4.subpoint-1',
          'listing.how-to-book.step-3.point-4.subpoint-2',
          'listing.how-to-book.step-3.point-4.subpoint-3'
        ]
      }
    ]
  },
  {
    id: 4,
    titleKey: 'listing.how-to-book.step-4.title',
    pointKeys: [
      { textKey: 'listing.how-to-book.step-4.point-1' },
      { textKey: 'listing.how-to-book.step-4.point-2' }
    ]
  }
];
